
import React, { useState } from 'react';
import { FiPlus, FiMinus } from 'react-icons/fi'; // Iconos de react-icons
import '../../css/TerminosDelSorteo.css'
import {CONSTANTES} from "../../config/constantaes";

const TerminosDelSorteo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  
 return (
    <div className='content-modal'>
      <div onClick={toggleAccordion} className='content-modal-titulo'>
        <strong className='titulo-term'>Términos del sorteo</strong>
        {isOpen ? <FiMinus color="#f44336" /> : <FiPlus color="#f44336" />}
      </div>

      <div className='context-modal'>
        {isOpen && (
            <p>
                <p>
                  Ganadores de la campaña "La Suerte Te Llama" La campaña "La Suerte Te Llama" tuvo vigencia del 04/05/2026 al 22/07/2026, con sorteos realizados el 29/05/2026, 26/06/2026 y 24/07/2026, conforme a los Términos y Condiciones publicados. Los premios consistieron en 96 vales de consumo de S/300 en tiendas Carsa y 4 motos eléctricas (modelo BM-X9, marca Roadland).  Los ganadores fueron seleccionados de acuerdo al mecanismo de participación establecido en las bases del sorteo. Más información de los términos y condiciones del sorteo en <a href="https://alfinbanco.pe/comunicados" target="_blank" rel="noopener noreferrer">www.alfinbanco.pe/comunicados</a>. 
                </p>

            </p>
        )}
      </div>
    </div>
 );
};

export default TerminosDelSorteo;